// Path: src\Components\Popup\CoinsClaimedPopup.jsx
import { React, useState } from "react";
import Coins from "../../images/coins.png";
import Coinsgroup from "../../images/Coins Group.png";
// import { ReactComponent as MultipleCoinsIcon } from '../../images/multiplecoins.svg';
import { ReactComponent as MultipleCoinsIcon } from "../../images/coinsgroup.svg";
import coin from "../../assets/images/coin.png";
import gems from "../../assets/images/gems.png";
import { url } from '../../config/url';
const Popup = ({ isOpen, onClose, title, children, reward }) => {
  if (!isOpen) return null;

  return (
    <div className="popupinner-wrapper">
      <div className="popup-overlay">
        <div className="popup-container coinsgroup-popup">
          <button className="close-btn" onClick={onClose}>
            <svg
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g opacity="0.8" filter="url(#filter0_b_2731_8186)">
                <circle
                  cx="16"
                  cy="16"
                  r="16"
                  fill="#82838E"
                  fill-opacity="0.5"
                />
              </g>
              <rect
                x="12.0531"
                y="10.9065"
                width="13.3333"
                height="1.96078"
                rx="0.980392"
                transform="rotate(45 12.0531 10.9065)"
                fill="#F4F4F4"
              />
              <rect
                x="10.6666"
                y="20.3345"
                width="13.3333"
                height="1.96078"
                rx="0.980392"
                transform="rotate(-45 10.6666 20.3345)"
                fill="#F4F4F4"
              />
              <defs>
                <filter
                  id="filter0_b_2731_8186"
                  x="-24"
                  y="-24"
                  width="80"
                  height="80"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feGaussianBlur in="BackgroundImageFix" stdDeviation="12" />
                  <feComposite
                    in2="SourceAlpha"
                    operator="in"
                    result="effect1_backgroundBlur_2731_8186"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_backgroundBlur_2731_8186"
                    result="shape"
                  />
                </filter>
              </defs>
            </svg>
          </button>

          {/* Start code from here */}
          {title && (
            <>
            {reward?.rewardAmount > 0 ?
              <div className="d-flex justify-content-center">
                <h2 className="popup-header-text mb-4 mt-2">
                  {reward?.rewardAmount}
                </h2>
                <div className="ms-2 mt-1" >
                <div style={{ width: "28px", height: "28px" }}>
 
    <img 
      src={`${url.IMAGE_URL}${reward.currency.img.default}`} 
      alt=" " 
      style={{ width: "100%", height: "100%", objectFit: "contain" }} 
    />
 
</div>

                </div>
              </div>
              :<div className="d-flex justify-content-center">
              <h2 className="popup-header-text mb-4 mt-5" style={{fontSize:"1.5rem"}}>
               Better Luck Next Time
              </h2>
            </div>
            }  

            </>
          )}
          <div className="popup-body">
            <div className="coins-claimed-popup">
              <div className="coins-claimed-title">
                {/* {reward?.currency?.name} */}
                <span>
                {" "}
           
              </span>
              {reward?.rewardAmount > 0 ? "claimed" :""}
              </div>
              <div className="coins-group coins-custom-group">
                <img className="" src={Coinsgroup} alt="coins"></img>
                {/* <MultipleCoinsIcon /> */}
              </div>
              <div className="coins-bunddle coins-bunddle-custombunddle">
                <img
                  className="coins-bunddle-img"
                  src={Coins}
                  alt="coins"
                ></img>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Popup;
